import { PricelistPeriodCreatePage } from '@/features/pricelist-period/pages/PricelistPeriodCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pricelist/period/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pricelist.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PricelistPeriodCreatePage,
})
